import Validation from '../validation/validation';
import Form from '../form/form';
import Notification from '../notification/notification';
import Modal from '../modal/modal';
import Helpers from '../js/helpers';
import SubscriptionPayment from '../subscription-payment/subscription-payment';

export default new class ModalSubscription {
  constructor() {
    this.btnSubmit = '.js-submit-form';
    this.tarifSelect = '.tariff-tab__select';
    this.checkboxSameData = '.js-toggleAdressBlock';
    this.postAddressCompany = '.js-postAddressCompany';
    this.subscrControlContainer = 'js-subscr-control-container';
    this.activePeriod = '.subscription__head-period._active';
    this.periodItem = 'subscription__head-period';
    this.cancelPromoBtn = '.js-cancel-promo';

    this.subscriptionModalOpenBtn = 'js-subscr-modal-open-btn';
    this.tabControl = 'data-form-tab-control';
    this.tabContent = 'data-form-tab';
    this.dataTariffIdAttr = 'data-tariff-id';
    this.dataPeriodIdAttr = 'data-period-id';

    this.conf = {
      openListClass: '_open',
      activeItemClass: '_active',
    };

    this.isLegal = 1;
    this.data = {};

    this.dropdown = 'dropdown-click';
    this.list = 'dropdown-click__list';
    this.item = 'dropdown-click__item';
    this.selectedItem = 'dropdown-click__selected';
    this.promoItemSelector = '.promo-item';
    this.promoSelector = '#promo';
    this.init();
  }

  init() {
    this.bindEvents();
    if (Helpers.isMobile()) {
      this.bindMobileEvents();
    }

    if ($(`.${this.subscriptionModalOpenBtn}`).attr('data-created') == 1) {
      const href = document.querySelector('a.invoice__caption-link');
      href.click();
    }
  }

  bindMobileEvents() {
    $(document)
      // change tariff tab by select
      .on('change', this.tarifSelect, (e) => {
        const tariffTab = $(e.currentTarget.options[e.currentTarget.selectedIndex]).attr('data-tab');

        $('.tariff-tab__pane').removeClass(this.conf.activeItemClass);
        $(`.tariff-tab__pane[data-tab='${tariffTab}']`).addClass(this.conf.activeItemClass);
      });
  }

  bindEvents() {
    const obThis = this;

    $(document)
      // submit form
      .on('click', this.btnSubmit, (e) => {
        e.preventDefault();
        const $obForm = $(e.target).closest('form');

        if (!Validation.isFormValid($obForm)) {
          return;
        }

        // set promo input disable/enable, depends on is promo input block active
        if ($('.promo-input-block').hasClass(this.conf.activeItemClass)) {
          $obForm.find(this.promoSelector).prop('disabled', false);
        } else {
          $obForm.find(this.promoSelector).prop('disabled', true);
        }

        $obForm.request('MakeOrder::onCreate', {
          data: {
            order: {
              type: 'product',
              payment_type_id: 1,
              property: {
                is_legal: this.isLegal,
              },
            },
          },
          success(response) {
            if (!response.X_OCTOBER_REDIRECT && !response.status) {
              Notification.showError(response && response.message);
            }

            // set input promo enabled
            $(this.promoSelector).prop('disabled', false);
            this.success(response);
          },
        });
      })
      // show/hide post address block
      .on('change', this.checkboxSameData, (e) => {
        const $formBlockToDisable = $(e.target).closest('form').find('.js-addressBlockToToggleDisable');

        Form.toggleFormDisable($formBlockToDisable, e.target.checked);
      })
      // close dropDown on body click
      .on('click', (e) => {
        if (!$(e.target).closest(`.${this.dropdown}`).length) {
          this.closeDropdownList();
        }
      })
      // open tariff plan dropdown
      .on('click', `.${this.dropdown}`, (e) => {
        if ($(`.${this.list}`).hasClass(this.conf.openListClass)) {
          this.closeDropdownList();
        } else {
          this.toggleDropdownList($(e.currentTarget));
        }
      })
      // change selected item in select
      .on('click', `.${this.item}`, (e) => {
        const $cancelPromoBtn = $(this.cancelPromoBtn);

        if ($cancelPromoBtn.hasClass(this.conf.activeItemClass)) {
          $cancelPromoBtn.trigger('click');
        }

        if (!$(e.currentTarget).hasClass(this.conf.activeItemClass)) {
          e.stopPropagation();
          this.toggleCurrentItem($(e.currentTarget));
        }
      })
      // toggle selected period
      .on('click', `.${this.periodItem}`, (e) => {
        const $cancelPromoBtn = $(this.cancelPromoBtn);

        if ($cancelPromoBtn.hasClass(this.conf.activeItemClass)) {
          $cancelPromoBtn.trigger('click');
        }

        this.togglePeriod($(e.target).closest(`.${this.periodItem}`));
      })
      // subscription tabs
      .on('click', '.subscription__body-tabs-item', (e) => {
        const $currentTabControl = $(e.currentTarget);
        const currentTabName = $currentTabControl.attr(this.tabControl);
        const tabItems = $(`[${this.tabContent}]`);

        this.isLegal = $currentTabControl.attr('data-is-legal');

        // set active link
        $('.subscription__body-tabs-item').removeClass('_active-link');
        $currentTabControl.addClass('_active-link');

        // set active tab
        tabItems.hide().removeClass(this.conf.activeItemClass);
        $(`[data-form-tab="${currentTabName}"]`).show().addClass(this.conf.activeItemClass);

        const $disabledForm = $('.subscription__body-pane:not(._active)');
        const $activeForm = $('.subscription__body-pane._active');

        // disable inactive tab, remove validation errors
        Form.toggleFormDisable($disabledForm, true);
        // enable active tab, remove validation errors
        Form.toggleFormDisable($activeForm, false);

        // set fields for .js-addressBlockToToggleDisable block
        // disable/enable, depends on post address company checkbox
        Form.toggleFieldsDisable($('.js-addressBlockToToggleDisable'), $('.js-toggleAdressBlock')[0].checked);
      })
      // subscription form modal open
      .on('touchstart click', `.${this.subscriptionModalOpenBtn}`, (e) => {
        e.preventDefault();
        const obButton = $(e.currentTarget);
        const iPaymentMethod = obButton.attr('data-payment-method-id');

        $.request('MakeOrder::onCreate', {
          data: {
            order: {
              type: 'product',
              payment_method_id: iPaymentMethod,
            },
            click: 1,
          },
          success(response) {
            if (!response.X_OCTOBER_REDIRECT && !response.status) {
              Notification.showError(response && response.message);
            }

            // set input promo enabled
            $(this.promoSelector).prop('disabled', false);
            this.success(response);
          },
        });
        // const $clickedLink = $(e.currentTarget);
        // const targetDataValue = $clickedLink.data('modal-link');
        //
        // /* if activate promo btn clicked in promo-code popup,
        // put promo-code in promo input in the subscription popup */
        // if ($clickedLink.closest('.js-modal-content').length) {
        //   const $cancelPromoBtn = $('.js-cancel-promo');
        //   const promoCode = $clickedLink.closest(this.promoItemSelector).attr('data-promo');
        //
        //   // put promo in subscription modal promo input
        //   $('.modal-subscription').find('.form-item__input[name="promo_code"]').val(promoCode);
        //   // close promo modal
        //   $('.modal-promo').find('.js-modal-close').trigger('click');
        //
        //   if ($cancelPromoBtn.hasClass(this.conf.activeItemClass)) {
        //     $cancelPromoBtn.trigger('click');
        //   }
        //   return;
        // }

        /* eslint-disable no-undef, no-empty */

        // if ($clickedLink.hasClass('_tarigg_group_id_1')) {
        //   try {
        //     yaCounter20830984.reachGoal('buyspecialist');
        //     ga('send', 'event', 'Button', 'buyspecialist');
        //   } catch (error) {}
        // } else if ($clickedLink.hasClass('_tarigg_group_id_2')) {
        //   try {
        //     yaCounter20830984.reachGoal('buyprofessional');
        //     ga('send', 'event', 'Button', 'buyprofessional');
        //   } catch (error) {}
        // }
        // if ($clickedLink.hasClass('_tarigg_group_id_3')) {
        //   try {
        //     yaCounter20830984.reachGoal('professionalplus');
        //     ga('send', 'event', 'Button', 'professionalplus');
        //   } catch (error) {}
        // }

        /* eslint-enable no-undef, no-empty */

        // $.request('ProductList::onAjaxRequest', {
        //   update: {
        //     'project/common/modal-subscription/modal-subscription': '.modal-subscription',
        //   },
        //   success(response) {
        //     const $promoItem = $clickedLink.closest(this.promoItemSelector);
        //
        //     obThis.tariffId = parseInt($clickedLink.attr('data-id'), 10);
        //
        //     if (!response && !response.result) {
        //       return;
        //     }
        //     obThis.data = JSON.parse(response.result);
        //
        //     get selected period, and tariff name
        //     const { period } = obThis.data[obThis.tariffId];
        //     const tariffName = obThis.data[obThis.tariffId].name;
        //
        //     set tariffs array, and selected tariff name
        //     obThis.tariffArr = obThis.setTariffNames();
        //     obThis.selectedTariff = tariffName;
        //
        //     this.success(response);
        //
        //     // append promocode in subscr popup promo input
        //     $('.form-item__input[name="promo_code"]').val($promoItem.attr('data-promo'));
        //
        //     // obThis.renderControls(period, obThis.tariffId, obThis.data);
        //     Modal.openModal($clickedLink, $(`.${Modal.modalContent}[data-modal='${targetDataValue}']`));
        //     Form.initMasks();
        //   },
        // });
      });
  }

  /**
   * Append controls for subscription form
   *
   * @param period - period id
   * @param tariff - tariff id
   */
  renderControls(periodParam = null, tariffParam = null) {
    let period = periodParam;
    let tariff = tariffParam;

    const $controlsContainer = $(`.${this.subscrControlContainer}`);
    const $totalPrice = $('.subscription__footer-total-val');

    // set selected value for period
    if (!period) {
      period = parseInt($(this.activePeriod).attr(this.dataPeriodIdAttr), 10);
    }

    // set selected value for tariff
    if (!tariff) {
      tariff = parseInt($(`.${this.selectedItem}`).attr(this.dataTariffIdAttr), 10);
    }

    // set total price
    $totalPrice.empty();
    $totalPrice.text(this.data[tariff].price);

    // append controls to subscription popup
    $controlsContainer.empty();
    $controlsContainer.append(
      `<div class="subscription__head-row __mb-20">
                <div class="subscription__head-select">
                    <div class="subscription__head-select-title">Тарифный план</div>

                    <div class="dropdown-click">
                        <div class="dropdown-click__selected dropdown-click__selected_subscription" data-tariff-id="${tariff}">
                            ${this.data[tariff].name}
                        </div>
                        <svg class="dropdown-click__arrow dropdown-click__arrow_subscription" fill="#000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8"><path d="M6 8l6-8L6 4 0 0 6 8z"/></svg>

                        <ul class="dropdown-click__list">
                            ${this.renderTariff(this.data[tariff].name)}
                        </ul>
                    </div>
                </div>
                <div class="subscription__head-price">
                    <span class="subscription__head-price-val" data-price="${this.data[tariff].price}">${this.data[tariff].price}</span>
                    <span class="subscription__head-price-cur">р.</span>
                </div>
            </div>
            <div class="subscription__head-row _controls">
                <div class="subscription__head-period ${+this.data[tariff].period === 3 ? this.conf.activeItemClass : ''}" data-period-id="3">
                    <span class="subscription__head-period-text">3 месяца</span>
                </div>
                    <div class="subscription__head-period ${+this.data[tariff].period === 6 ? this.conf.activeItemClass : ''}" data-period-id="6">
                    <span class="subscription__head-period-text">Полгода</span>
                </div>
                    <div class="subscription__head-period ${+this.data[tariff].period === 12 ? this.conf.activeItemClass : ''}" data-period-id="12">
                    <span class="subscription__head-period-text">Годовая подписка</span>
                </div>
            </div>


        `,
    );
  }


  /**
   *  Create this.tariffsArr with all tariffs
   */
  setTariffNames() {
    this.tariffsArr = [];

    Object.keys(this.data).forEach((key) => {
      if (!this.tariffsArr.length) {
        this.tariffsArr.push(this.data[key]);
      } else {
        let isAdded = false;

        for (let i = 0; i < this.tariffsArr.length; i += 1) {
          if (this.tariffsArr[i].name === this.data[key].name) {
            isAdded = true;
            break;
          }
        }

        if (!isAdded) {
          this.tariffsArr.push(this.data[key]);
        }
      }
    });
  }

  /**
   * Create html of all tariffs
   *
   * @returns {string} - html of available tariffs
   */
  renderTariff(tariffName) {
    let html = '';

    for (let i = 0; i < this.tariffsArr.length; i += 1) {
      html += `<li class="dropdown-click__item __tr-cl-bg ${this.tariffsArr[i].name === tariffName ? this.conf.activeItemClass : ''}" data-tariff-id="${this.tariffsArr[i].id}">
                ${this.tariffsArr[i].name}
            </li>`;
    }

    return html;
  }

  /**
   * Toggle period
   *
   * @param $periodItem - jQuery obj of clicked period item
   */
  togglePeriod($periodItem) {
    if (!$periodItem.hasClass(this.conf.activeItemClass)) {
      const period = +$periodItem.attr(this.dataPeriodIdAttr);
      const $selectedTariff = $(`.${this.selectedItem}`);
      const selectedTariffName = $selectedTariff.text();

      // remove active class for all items
      $(`.${this.periodItem}`).removeClass(this.conf.activeItemClass);
      $periodItem.addClass(this.conf.activeItemClass);

      let tariff = null;

      // get tariff id for current period and tariff plan
      Object.keys(this.data).some((key) => {
        const dataName = this.data[key].name;
        const selectedName = selectedTariffName.trim();
        const dataPeriod = this.data[key].period;

        if (dataName === selectedName && dataPeriod === period) {
          tariff = this.data[key].id;
          $(`.${this.selectedItem}`).attr(this.dataTariffIdAttr, tariff);
          this.tariffId = tariff;
          return true;
        }

        return false;
      });

      this.renderControls(period, tariff);
    }
  }

  /**
   * Toggle dropdown list on title click
   *
   * @param {object} $dropdown
   */
  toggleDropdownList($dropdown) {
    $dropdown.find(`.${this.list}`).toggleClass(this.conf.openListClass);
  }

  /**
   * Toggle active item in dropdown and hide list
   *
   * @param {object} $item
   */
  toggleCurrentItem($item) {
    const $dropdown = $item.closest(`.${this.dropdown}`);
    const $selectedItem = $dropdown.find(`.${this.selectedItem}`);

    $item.closest(`.${this.list}`).find(`.${this.item}`).removeClass(this.conf.activeItemClass);
    $item.addClass(this.conf.activeItemClass);

    $selectedItem.text($item.text());
    $dropdown.find(`.${this.list}`).removeClass(this.conf.openListClass);

    // set selected tariff
    this.tariffId = $item.attr(this.dataTariffIdAttr);
    $selectedItem.attr(this.dataTariffIdAttr, this.tariffId);

    this.renderControls();
  }

  /**
   * Hide dropdown list on outside click
   */
  closeDropdownList() {
    $(`.${this.list}`).removeClass(this.conf.openListClass);
  }
}();
